/**
 * Hub Home (v2 frame "Hub · Home"). A greeting and one sentence, then the apps as rows; every row
 * is a link and the only control on the page. No cards, no tiles, no buttons.
 *
 * Until each app has a summary endpoint the hub can read, Home shows the greeting and the apps
 * with your role; the "needs you" rows and the per-app figures are drawn in the frame and slot in
 * then (design build note, 30 Oct).
 */
import { Link } from 'react-router-dom';
import { Group, Headline, Row } from '@buckmason/cx-ui';
import { useAuth } from '../lib/auth';
import { useTitle } from '../lib/useTitle';

function greeting(now = new Date()) {
  const h = now.getHours();
  return h < 12 ? 'Good morning' : h < 18 ? 'Good afternoon' : 'Good evening';
}

export function Home() {
  useTitle('Home');
  const { me, isAdmin } = useAuth();
  if (!me) return null;
  const first = me.name.split(' ')[0];

  return (
    <div className="page arrive">
      <Headline title={`${greeting()}, ${first}`}>
        {me.apps.length === 0
          ? isAdmin
            ? 'You have no apps yet. Give yourself access on People.'
            : 'You have no apps yet. Ask an admin to give you access.'
          : me.apps.length === 1
            ? 'One app is yours to open.'
            : `${me.apps.length === 2 ? 'Two' : me.apps.length} apps are yours to open.`}
      </Headline>

      {me.apps.length > 0 ? (
        <Group heading="Your apps">
          {me.apps.map((a) => (
            <Row key={a.key} href={a.url} title={a.name} meta={a.roleName} />
          ))}
        </Group>
      ) : (
        isAdmin && (
          <Group>
            <Row as={Link} to="/people" title="People" meta="Give yourself access to an app" />
          </Group>
        )
      )}
    </div>
  );
}
